import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=d04a1972&scoped=true&"
import script from "./ProductRelated.vue?vue&type=script&lang=js&"
export * from "./ProductRelated.vue?vue&type=script&lang=js&"
import style0 from "./ProductRelated.vue?vue&type=style&index=0&id=d04a1972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a1972",
  null
  
)

export default component.exports